import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import {
    deleteConceptForm,
    getConceptFormById,
    pagingConceptForm,
    saveConceptForm
} from 'app/services/ConceptFormService';
import { ConceptForm } from "app/common/Model/ConceptForm";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";
import { importConceptFormExcel } from "app/services/ImportExcelService";

export default class ConceptFormStore {
    searchConceptForm = new SearchObject();
    pageConceptForm = null;
    selectedConceptForm = null;
    openFormCreateOrEdit = false;
    openConfirmDeleteConceptForm = false;
    openImportExcel = false;

    constructor() {
        makeAutoObservable(this);
    }
    handleOpenImportExcel = () => {
        this.openImportExcel = true;
    }
    handleCloseImportExcel = () => {
        this.openImportExcel = false;
    };
    saveImportExcelConcept = (file) => {
        importConceptFormExcel(file).then(() => {
            toast.success("Nhập excel thành công")
            this.searchConcept = {
                ...this.searchConcept,
                pageIndex: 1
            }
            this.pagingConceptForm();
            this.openImportExcel = false;
        }).catch(() => {
            toast.error("Nhập excel thất bại")
        }).
            finally(() => {
                this.handleClosePopup();
            })
    }

    pagingConceptForm = async (searchObj) => {
        let newSearchObj = { ...this.searchConceptForm, ...searchObj }
        return await pagingConceptForm(newSearchObj)
            .then(({ data }) => {
                this.pageConceptForm = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi");
            })
    }

    handleChangeFormSearch = (searchConceptForm) => {
        this.searchConceptForm = {...this.searchConceptForm, ...searchConceptForm};
        this.pagingConceptForm();
    }

    handleOpenFormCreateOrEdit = (conceptFormId) => {
        if (Boolean(conceptFormId)) {
            getConceptFormById(conceptFormId)
                .then(({ data }) => {
                    if (data.conceptFormOrderList) {
                        data.conceptFormOrderList = data.conceptFormOrderList.map(item => {
                            if (item.defaultTextValue === null) {
                                const { defaultTextValue, ...rest } = item;
                                return rest;
                            }
                            return item;
                        });
                    }

                    this.selectedConceptForm = data;
                    this.openFormCreateOrEdit = true;
                })
                .catch((error) => {
                    console.error(error);
                    toast.error("Lấy dữ liệu có lỗi");
                })
        } else {
            this.selectedConceptForm = new ConceptForm();
            this.openFormCreateOrEdit = true;
        }
    }

    saveConceptForm = async (conceptForm, { setSubmitting }) => {
        return await saveConceptForm(conceptForm).then(() => {
            this.selectedConceptForm = null;
            toast.success("Lưu mẫu kết quả thành công!");
            this.handleClosePopup();
            this.pagingConceptForm();
        })
            .catch(error => {
                console.error(error);
                toast.error("Lưu thông tin mẫu kết quả có lỗi");
            })
            .finally(() => setSubmitting(false))
    }

    handleDeleteConceptForm = (conceptForm) => {
        this.selectedConceptForm = { id: conceptForm?.id };
        this.openConfirmDeleteConceptForm = true;
    }

    handleConfirmDeleteConceptForm = () => deleteConceptForm(this?.selectedConceptForm?.id)
        .then(() => {
            if (this.searchConceptForm.pageIndex > 1 && this.pageConceptForm?.content?.length === 1) {
                this.searchConceptForm.pageIndex -= 1;
            }
            toast.success("Xóa mẫu kết quả thành công!")
            this.handleClosePopup();
            this.pagingConceptForm();
        })
        .catch(err => {
            console.error(err);
            toast.error("Xóa mẫu kết quả có lỗi");
        })

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteConceptForm = false;
        this.openImportExcel = false;
    }

    resetStore = () => {
        this.searchConceptForm = new SearchObject();
        this.pageConceptForm = null;
        this.selectedConceptForm = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteConceptForm = false;
    }
}